import set from "lodash/set";
import get from "lodash/get";
if (typeof window.MdcEventBusStorage === "undefined") {
    window.MdcEventBusStorage = {};
}
const getEventName = (topic) => `MdcEventBus:${topic}`;
export const createEventBus = () => {
    const setLatestForTopic = (topic, event) => {
        set(window.MdcEventBusStorage, topic, event);
    };
    const getLatestFromTopic = (topic) => {
        return get(window.MdcEventBusStorage, `${topic}.detail`);
    };
    const observe = (...args) => {
        const unsubscriptions = [];
        const topics = args.slice(0, -1);
        const lastArg = args[args.length - 1];
        const { callback, skipLatest = false, ...options } = (typeof lastArg === "function"
            ? { callback: lastArg }
            : lastArg);
        topics.forEach((topic) => {
            const eventHandler = () => callback(...topics.map((topic) => getLatestFromTopic(topic)));
            window.addEventListener(getEventName(topic), eventHandler, options);
            unsubscriptions.push(() => window.removeEventListener(getEventName(topic), eventHandler));
        });
        if (!skipLatest) {
            const latestValues = topics.map((topic) => getLatestFromTopic(topic));
            // don't emit initial if all latestValues are undefined
            if (latestValues.filter((value) => value !== undefined).length > 0) {
                callback(...latestValues);
            }
        }
        return () => unsubscriptions.forEach((unsub) => unsub());
    };
    const dispatch = (topic, data) => {
        if (data !== getLatestFromTopic(topic)) {
            const event = new CustomEvent(getEventName(topic), {
                detail: data,
            });
            setLatestForTopic(topic, event);
            window.dispatchEvent(event);
        }
    };
    return { observe, dispatch, getLatestFromTopic };
};
export const { observe, dispatch, getLatestFromTopic } = createEventBus();
//# sourceMappingURL=event-bus.js.map